AifsDisplayFormController.$inject = ['$scope', '$element', '$attrs', 'MetaForm']
function AifsDisplayFormController($scope, $element, $attrs, MetaForm) {
    var self = this;

    var subscription = {};
    this.subscribeField = function (fieldName, callback) {
        if (!subscription[fieldName]) {
            subscription[fieldName] = [];

            $scope.$watch('model.' + fieldName, function (newValue, oldValue) {
                angular.forEach(subscription[fieldName], function (callback) {
                    callback();
                });
            }, true);
        }
        subscription[fieldName].push(callback);
    };

    var mapRulesToQuestion = {}; // for each BusinessQueston we have a list of Question that used the BusinessQueston
    var questions = {};

    var metaForm = new MetaForm($attrs.id);
    metaForm.getBusinessRules(init);


    this.Id = $attrs.id;


    this.$addQuestion = function (question) {
        questions[question.$id] = question;

        if (question.questionRule && question.questionRule.businessRules) {
            angular.forEach(question.questionRule.businessRules, function (rule) {
                if (!mapRulesToQuestion[rule.id])
                    mapRulesToQuestion[rule.id] = [];

                mapRulesToQuestion[rule.id].push(question);
            });
        }
    };

    function init(businessRules) {
        self.businessRules = businessRules;

        // for each of field make a list of rules that will be affected when the field change
        angular.forEach(businessRules, function (rule, ruleName) {
            angular.forEach(rule.components, function (component) {

                self.subscribeField(component.field, function () {
                    if (rule.checkIfChanged.call(rule, $scope.model)) {

                        angular.forEach(mapRulesToQuestion[rule.id], function (question) {

                            if (question && question.$updateRule)
                                question.$updateRule();
                        });
                    }
                });
            });
        });
    }


    $scope.formId = $attrs.id;

    $scope.$on('submitted', function (event, value) {
        $scope.submitted = value;
    });

}

angular
    .module("aifs.metaform")
    .directive("aifsDisplayForm", function () {
        return {
            restrict: 'A',
            controller: AifsDisplayFormController
        };
    });
